/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  //base: process.env.BASE_URL,
  base: '/',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: ':nameCompany',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        // {
        //   path: '/',
        //   name: 'home',
        //   component: () => import('./views/Home.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     windowRedirectAfter: true
        //   }
        // },
        {
          path: '/:nameCompany',
          name: 'home',
          //component: () => import('./views/Home.vue'),
          component: () => import('@/views/caso/CasoListView.vue'),
          meta: {
            requiresAuth: true,
            windowRedirectAfter: true
          },
          props: true
        },
        // {
        //   path: "/page2",
        //   name: "page-2",
        //   component: () => import("./views/Page2.vue")
        // },
        /*{
          path: '/:nameCompany/casos',
          name: 'casos',
          component: () => import('@/views/caso/CasoListView.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { title: 'Inicio', url: '/:nameCompany' },
              { title: 'Casos', active: true }
            ],
            pageTitle: 'Casos',
            rule: 'editor'
          }
        },*/
        {
          path: '/:nameCompany/caso/:idRequest',
          name: 'caso',
          component: () => import('@/views/caso/CasoByIdView.vue'),
          meta: {
            requiresAuth: true,
            windowRedirectAfter: true
          },
          props: true
        },
        {
          path: '/:nameCompany/reportes/casos',
          name: 'reportes',
          component: () => import('@/views/reporte/ReporteListView.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { title: 'Inicio', url: '/:nameCompany' },
              { title: 'Reporte', active: true}
            ],
            pageTitle: 'Reportes',
            rule: 'editor'
          }
        },
        {
          path: '/:nameCompany/reportes/casos_cerrados',
          name: 'reportes',
          component: () => import('@/views/reporte/ReporteListView.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { title: 'Inicio', url: '/:nameCompany' },
              { title: 'Reporte', active: true}
            ],
            pageTitle: 'Reporte - Casos cerrados',
            rule: 'editor'
          }
        },
        /*
        submenu
        {
          path: '/:nameCompany/reportes',
          redirect: '/:nameCompany/reportes/casos_cerrados'
        },
        {
          path: '/:nameCompany/reportes/casos_cerrados',
          name: 'reportes-casos-cerrados',
          component: () => import('@/views/reporte/ReporteListView.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { title: 'Inicio', url: '/:nameCompany' },
              { title: 'Reportes'},
              { title: 'Casos cerrados', active: true }
            ],
            pageTitle: 'Reporte - Casos cerrados',
            rule: 'editor'
          }
        },*/

        // {
        //   path: '/:nameCompany/indicadores',
        //   name: 'indicadores',
        //   component: () => import('@/views/indicador/IndicadorUsuario.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     breadcrumb: [
        //       { title: 'Inicio', url: '/:nameCompany' },
        //       { title: 'Indicadores', active: true }
        //     ],
        //     pageTitle: '',
        //     rule: 'editor'
        //   }
        // }
        {
          path: '/:nameCompany/usuario/perfil',
          name: 'ajustes-perfil',
          component: () => import('@/views/user/user-settings/UserSettings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/:nameCompany' },
              { title: 'Usuario'},
              { title: 'Perfil', active: true }
            ],
            pageTitle: 'Perfil',
            rule: 'editor'
          }
        },
        {
          path: '/:nameCompany/configuraciones',
          name: 'configuraciones',
          component: () => import('@/views/configuraciones/Configuraciones.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/:nameCompany' },
              { title: 'Configuraciones', active: true}
            ],
            pageTitle: 'Configuraciones',
            rule: 'editor'
          }
        },
        {
          path: '/:nameCompany/configuraciones/cuenta-aliada',
          name: 'cuenta-aliada',
          component: () => import('@/views/configuraciones/cuenta-aliada/CuentaAliadaListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/:nameCompany' },
              { title: 'Configuraciones', url: '/:nameCompany/configuraciones' },
              { title: 'Cuentas aliadas', active: true }
            ],
            pageTitle: 'Cuentas aliadas',
            rule: 'editor'
          }
        },
        {
          path: '/:nameCompany/configuraciones/subproyectos',
          name: 'subproyectos',
          component: () => import('@/views/configuraciones/subproyectos/SubproyectosListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Inicio', url: '/:nameCompany' },
              { title: 'Configuraciones', url: '/:nameCompany/configuraciones' },
              { title: 'Subproyectos', active: true }
            ],
            pageTitle: 'Subproyectos',
            rule: 'editor'
          }
        },

      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: ':nameCompany',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/:nameCompany/encuesta/:idRequest',
          name: 'encuesta',
          component: () => import('./views/formularios/FormularioEncuesta.vue')
        },
        {
          path: '/:nameCompany/auth/login',
          name: 'auth-login',
          component: () => import('@/views/auth/Login.vue')
        },
        {
          path: '/:nameCompany/auth/logout',
          name: 'page-logout',
          component: () => import('@/views/auth/Logout.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/:nameCompany/auth/error-404',
          name: 'page-error-404',
          component: () => import('@/views/auth/Error404.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '/:nameCompany/*',
      name: '404'
      //redirect: '/auth/error-404'
    }
  ]
})

function nextCheck (context, middleware, index) {
  const nextMiddleware = middleware[index]

  if (!nextMiddleware) return context.next

  return (...parameters) => {
    context.next(...parameters)
    const nextMidd = nextCheck(context, middleware, index + 1)

    nextMiddleware({ ...context, next: nextMidd })
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]

    const ctx = {
      from,
      next,
      router,
      to
    }

    const nextMiddleware = nextCheck(ctx, middleware, 1)

    return middleware[0]({ ...ctx, next: nextMiddleware })
  }

  return next()
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
